// extracted by mini-css-extract-plugin
module.exports = {"vendorName":"style_vendorName__3ZCHn","btnSecondaryGrey":"style_btnSecondaryGrey__1oXZA","waves-effect":"style_waves-effect__1YLcX"};